<div class="bg-img-container">
  <div class="container">
    <div class="form">
      <h2 id="heading">Report Time</h2>
      <form
        name="form"
        (ngSubmit)="f.form.valid && ok()"
        #f="ngForm"
        novalidate
      >
        <div>
          <mat-form-field>
            <input
              matInput
              placeholder="Select Date"
              name="selDate"
              [matDatepicker]="picker"
              required
              [formControl]="date"
              [max]="max"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker [startView]="startView" disabled="false">
            </mat-datepicker>
            <mat-error *ngIf="date.invalid">Invalid Date</mat-error>
          </mat-form-field>
        </div>

        <div>
          <button id="generate-daily-report" mat-raised-button class="login">
            Ok
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
